var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCm = function SvgIconCm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.218 1.191A11.95 11.95 0 0 0 12 .001c-1.87 0-3.64.427-5.217 1.19l-1.044 10.81L6.783 22.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.427 5.218-1.19L18.26 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 7.825 1.036 3.189h3.353l-2.713 1.97 1.036 3.19L12 14.202l-2.712 1.97 1.036-3.188-2.713-1.971h3.353z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M6.783 1.192A12 12 0 0 0 0 12a12 12 0 0 0 6.783 10.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.218 1.192v21.617A12 12 0 0 0 24 12.001a12 12 0 0 0-6.782-10.81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCm;